/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 29,
  image: "default-changelog-v2.png",
  title: "Spheron Platform Improvements, Compute Docs, Nftystore",
  shortDescription: "We have added a couple of improvements and fixes to the Spheron platform. Released an app Nftystore which allows you to upload NFT collections. Documentations now include detailed information about the Compute part of the platform. We have introduced the Decentralized Subscription Payment Toolkit",
  description: "We have added a couple of improvements and fixes to the Spheron platform. Released an app Nftystore which allows you to upload NFT collections. Documentations now include detailed information about the Compute part of the platform. We have introduced the Decentralized Subscription Payment Toolkit",
  date: "May 5th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Docs"]
};
export const content = `
## [Spheron Platform](https://app.spheron.network/) Fixes & Improvements 🛠️
- We have added the delete option for Auth Needed deployments.
- We have resolved the bug that was happening when opening deployment links.
- We have resolved the issue that was caused the deployments for some projects to last longer with the changes that were made with the previous release.
- We have fixed the issue that the update of the cluster configuration was not working.

<div className="image-box-shadow">
  <img
    src="/changelog/2023-05-05/nftystore.png"
    alt="choose-provider-screen"
    className="rounded-[12px]"
  />
</div>

## [Nftystore](https://nftystore.io/)

We are thrilled to announce the launch of our Nftystore, a user-friendly solution for uploading NFT collections across multiple blockchains. With Spheron multi-chain support, users can now quickly and efficiently upload their NFT collections to IPFS, FIlecoin or Arweave, empowering them to build their NFT collections with ease.
Our Nftystore simplifies the process of creating and managing NFT collections through three straightforward steps:

- **Choose your upload protocol:** Users can select their preferred upload protocol, either IPFS or Arweave, depending on their needs and the specific requirements of their NFT collections.
- **Upload your NFT collection:** Once the desired protocol is selected, users can quickly and securely upload their NFT collection assets to the chosen platform. Our service ensures that the process is fast and efficient, reducing wait times and optimizing the user experience.
- **Select Collection Base URI:** After the NFT collection assets have been uploaded, users can select their preferred gateway to access the collection base URI. We highly recommend using the Spheron Gateway, as it is super-charged with edge CDN, ensuring faster and more reliable access to the user's NFT collection.

Our website offers an intuitive and seamless experience for uploading NFT collections, making it simple and accessible for users of all experience levels. We are proud to provide this innovative solution to the NFT community and look forward to supporting the ongoing growth and development of the digital art and collectibles ecosystem.

## Introducing the Decentralized Subscription Payment Toolkit

We are excited to unveil the launch of [Desub Contracts](https://github.com/spheronFdn/subscriptions-contract), a comprehensive suite of Solidity smart contracts that enable hassle-free recurring and one-time cryptocurrency payments for both individuals and organizations in a decentralized environment.

To complement our smart contract suite, we are also proud to present [Desub Js](https://github.com/spheronFdn/desub-js), the ultimate solution for seamless integration and management of Decentralized Subscription Contracts. Developed by Spheron, it is the perfect tool for streamlining payment processing and subscription management for organizations of all sizes.

## [Spheron CLI](https://www.npmjs.com/package/@spheron/cli)

We have added a new dapp template called LYNC-claimer-page, checkout the [repository](https://github.com/LYNC-WORLD/NFT-Collection-dApp-Template) for more details.

## [Compute Docs](https://docs.spheron.network/compute/cluster/)

- We are happy to introduce the documentation for our compute platform. The Compute docs, include a comprehensive guide on utilizing Compute effectively.

## [Docs Changes](https://docs.spheron.network/)

- Introduced detailed documentation for the Browser Upload SDK, covering its features and implementation.
- Enhanced the Spheron CLI installation guide with clearer instructions and troubleshooting tips.
- Corrected and optimized the example code for the Upload method within the Storage SDK to ensure proper functionality.

## Revamped Changelog

We have significantly enhanced the appearance and design of our changelog for a more visually appealing and user-friendly experience.
`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
